import useCreateBillingRecorency, {
  CreateBillingRecorencyProps,
  translatedCreateBillingRecorencyProps,
} from 'modules/cities/hooks/use-create-company-billing';
import useCompaniesSelectData from 'modules/companies/hooks/use-companies-select-data';
import {useLocation, useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateBillingRecorency: React.FC = () => {
  const {id} = useParams();
  const {state} = useLocation();
  const {getSelect} = useFormInputs<CreateBillingRecorencyProps>();
  const companiesSelect = useCompaniesSelectData();

  return (
    <Creation
      translationKey={translatedCreateBillingRecorencyProps}
      defaultValues={state}
      onSubmit={() => useCreateBillingRecorency(id!)}
      inputs={[
        getSelect({
          name: 'companyId',
          data: companiesSelect.data,
          isLoading: companiesSelect.isLoading,
          disabled: !!(state as CreateBillingRecorencyProps)?.companyId,
        }),
        getSelect({
          name: 'billingRecorency',
          data: [
            {label: 'Semanal', value: 'WEEKLY'},
            {label: 'Quinzenal', value: 'FORTNIGHTLY'},
            {label: 'Mensal', value: 'MONTHLY'},
          ],
        }),
      ]}
      border
    />
  );
};

export default CreateBillingRecorency;
